<div [ngClass]="{'time-picker': true, 'time-picker_disabled': disabled}" (click)="openTimePicker()">
   <span [ngClass]="{'time-picker__text': true, 'time-picker__text__disabled': disabled || !selectedTime || !selectedDateTime}">
      <ng-container *ngIf="selectedTime">{{midnightSelected ?  'Midnight of the following day' : selectedTime}}</ng-container>
      <ng-container *ngIf="selectedDateTime && !midnightSelected"> ({{ selectedDateTime | timeZoneAbbreviation:timeZoneId }})</ng-container>
      <ng-container *ngIf="!selectedTime || !selectedDateTime">Select Time</ng-container>
   </span>
</div>
